module.exports = "/dist/e1158760006aaadbb9251b4e89b73e32.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-600.eot
// module id = 16
// module chunks = 0